import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";
import { useToast } from "../../components/ToastProvider";

export default function DoctorLogin() {
  const toast = useToast();

  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [showPwd,  setShowPwd]  = useState(false);
  const [loading,  setLoading]  = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/doctor/login", { email, password });
      sessionStorage.setItem("doctorToken", res.data.token);
      sessionStorage.setItem("doctorLoginTimestamp", Date.now().toString());

      sessionStorage.setItem(
        "doctorUser",
        JSON.stringify({
          id:   res.data.doctor.id,
          name: res.data.doctor.name,
          hasMedicineSuggestions: res.data.doctor.hasMedicineSuggestions || false,
          hasDiseaseSuggestions:  res.data.doctor.hasDiseaseSuggestions  || false,
        })
      );

      window.location.href = "/staff-portal/dashboard";
    } catch (err) {
      setLoading(false);
      toast("Invalid doctor credentials", "error");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-100 p-4">

      {/* Back to public site */}
      <div className="w-full max-w-sm mb-4">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-green-700 hover:text-green-900 transition">
          ← Back to Clinic Website
        </Link>
      </div>

      <form onSubmit={submit} className="card w-full max-w-sm space-y-4">
        <div className="text-center">
          <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-3 text-white text-xl">
            🩺
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Doctor Login</h1>
          <p className="text-sm text-gray-400 mt-1">OPD Management System</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            className="input"
            type="email"
            placeholder="doctor@clinic.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
          <div className="relative">
            <input
              type={showPwd ? "text" : "password"}
              className="input pr-11"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPwd(p => !p)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition text-lg"
              tabIndex={-1}
              aria-label={showPwd ? "Hide password" : "Show password"}
            >
              {showPwd ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <div className="text-right -mt-2">
          <Link to="/staff-portal/forgot-password" className="text-xs text-green-700 hover:text-green-900 font-medium transition">
            Forgot password?
          </Link>
        </div>

        <button type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? "Logging in…" : "Login"}
        </button>

        <p className="text-center text-xs text-gray-400">
          First time?{" "}
          <span className="text-gray-500">Contact admin to create your account.</span>
        </p>
      </form>

      <div className="mt-6 flex gap-4 text-sm text-gray-500">
        <Link to="/"        className="hover:text-green-700 transition">Home</Link>
        <Link to="/about"   className="hover:text-green-700 transition">About</Link>
        <Link to="/request" className="hover:text-green-700 transition">Appointment</Link>
      </div>

    </div>
  );
}